import { render, staticRenderFns } from "./JournalFileUploadButton.vue?vue&type=template&id=bc544c4c&scoped=true&"
import script from "./JournalFileUploadButton.vue?vue&type=script&lang=ts&"
export * from "./JournalFileUploadButton.vue?vue&type=script&lang=ts&"
import style0 from "./JournalFileUploadButton.vue?vue&type=style&index=0&id=bc544c4c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc544c4c",
  null
  
)

export default component.exports